import type * as DeviceHeaderBundle from '@foundation-player/plugin-device-header';
import { PluginFactoryFunction } from '../builder-config';
import { PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createDeviceHeaderPlugin: PluginFactoryFunction = () => {
  const deviceHeaderPackage = PackageName.PluginDeviceHeader;

  return [
    [deviceHeaderPackage],
    () => {
      return [new (resolveByPackageNameOrThrow<typeof DeviceHeaderBundle>(deviceHeaderPackage).DeviceHeaderPlugin)()];
    },
  ];
};
